import Form from 'src/utils/Form.js'

class Operator extends Form {
  constructor(data, config = null) {
    super(data, config || Form.config)
  }

  fetch(then) {
    return super.get(`operators/${this.id}/edit`).then(data => {
      this.originalData = data
      for (let field in this.originalData) {
        this[field] = data[field]
      }
      then(data)
    })
  }

  static all(parameters, then) {
    return new Form().get(`operators?${parameters}`).then(then)
  }

  users(then) {
     return super.get(`operators/${this.id}/users`).then(then)
  }

  ordersSummary(then) {
    return super.get(`operators/${this.id}/summary`).then(then)
  }

  attachUser(user_id, then) {
      return super.post(`operators/${this.id}/users/${user_id}/attach`).then(then)
  }

  detachUser(user_id, then) {
      return super.post(`operators/${this.id}/users/${user_id}/detach`).then(then)
  }

  create(then) {
    return super.post(`operators`).then(then)
  }

  update(then) {
    return super.patch(`operators/${this.id}`).then(then)
  }

  destroy(then) {
    return super.delete(`operators/${this.id}`).then(then)
  }
}

export default Operator
